// @ts-nocheck
/**
 * Decides what the component stage draws for the current selection.
 * Tree and editor keep the document node; only this module may substitute a preview instance.
 */
import {
  isWidgetVisualTreeKey,
  parseWidgetTreeKey,
  widgetVisualTreeKey,
} from "./keys.js";
import {
  materializeWidgetNode,
  previewWidgetTarget,
} from "../contract/widgets.js";

function walkItems(node, indices) {
  let current = node;
  for (const index of indices) {
    const next = current?.items?.[index];
    if (!next) break;
    current = next;
  }
  return current;
}

export function planComponentPreview({
  doc,
  selectedKey,
  surfaceRoot,
  resolveNode,
  previewModeFor,
  pageElements,
  dataset,
  widgets,
  vars,
  previewDatasetKind,
}) {
  if (selectedKey?.startsWith("widget:")) {
    const parsed = parseWidgetTreeKey(selectedKey);
    const name = parsed?.name;
    const previewMode = previewModeFor(name);
    let instance = name
      ? previewWidgetTarget(name, doc, {
        previewMode,
        phaseByWidget: name ? { [name]: previewMode } : undefined,
      })
      : null;
    if (!instance && name && widgets?.[name]) {
      instance = { widget: name };
    }
    const slotActiveLinkId = doc?.chrome?.sidebar?.data?.active_link_id;
    const ctx = {
      elements: pageElements ?? {},
      elementErrors: [],
      dataset: dataset ?? {},
      previewDatasetKind,
      widgets: widgets ?? {},
      previewMode,
      phaseByWidget: name ? { [name]: previewMode } : {},
      vars: vars ?? {},
      activeLinkId: name === "app_sidebar" && typeof slotActiveLinkId === "string" ? slotActiveLinkId : "",
    };
    const expanded = instance ? materializeWidgetNode(instance, ctx) : null;
    let node = expanded ?? resolveNode(selectedKey);
    if (isWidgetVisualTreeKey(selectedKey) && expanded) {
      node = walkItems(expanded, parsed.indices) ?? expanded;
    }
    let path = widgetVisualTreeKey(name);
    if (isWidgetVisualTreeKey(selectedKey)) {
      path = selectedKey;
    }
    return {
      kind: "widget-visual",
      node,
      path,
      previewMode,
    };
  }

  if (selectedKey?.startsWith("element:")) {
    return {
      kind: "element",
      node: resolveNode(selectedKey),
      path: selectedKey,
      previewMode: undefined,
    };
  }

  return {
    kind: "surface",
    node: surfaceRoot,
    path: selectedKey,
    previewMode: undefined,
  };
}
